export const REQUEST_TIMEOUT = 30000;
export const AUTH_TOKEN_NAME = "auth0.access.token";
export const NEW_PORTAL_COOKIE = "new-portal";
export const LOGGED_IN_AS = "logged-in-as";
